// Shared helpers for the Matrix Compliance page.
import dayjs from "dayjs";

export const sanitizeNumber = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(/[^0-9]/g, "");
};

// ── Formats a raw digit string with thousands separators for display ───────
export const formatWithCommas = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  return Number.isFinite(num) ? num.toLocaleString("en-US") : value;
};

export const buildDateRange = (fromDate, toDate) => {
  if (!fromDate || !toDate) return [];
  let dates = [];
  let currentDate = dayjs(fromDate);
  const endDate = dayjs(toDate);
  while (currentDate.isBefore(endDate) || currentDate.isSame(endDate)) {
    dates = [...dates, currentDate.format("MM/DD/YYYY")];
    currentDate = currentDate.add(1, "day");
  }
  return dates;
};
